module.exports = __webpack_public_path__ + "img/Profilprofi.4663ebf6.jpg";